const COLORS = {
  light: { wordmark: "#0A192F", tagline: "#1A1A1A", brass: "#B89745" },
  reversed: { wordmark: "#FAF9F6", tagline: "#E9E6DF", brass: "#B89745" },
};

export const BrandMark = ({ className = "", title = "One More Shift brand mark" }) => (
  <svg viewBox="0 0 100 100" className={className} role="img" aria-label={title} data-testid="brand-mark">
    <path
      d="M 62.0 75.8 A 28.5 28.5 0 1 1 77.5 57.4"
      fill="none"
      stroke="#B89745"
      strokeWidth="10"
      strokeLinecap="round"
    />
  </svg>
);

export const BrandLogo = ({ variant = "light", className = "h-12 w-auto" }) => {
  const c = COLORS[variant] || COLORS.light;
  return (
    <span
      className="inline-flex flex-col"
      role="img"
      aria-label="One More Shift — Experience Doesn't Retire."
      data-testid="brand-logo"
    >
      <svg viewBox="0 0 560 112" className={className}>
        <line x1="30" y1="34" x2="240" y2="34" stroke={c.brass} strokeWidth="3" strokeLinecap="round" />
        <line x1="320" y1="34" x2="530" y2="34" stroke={c.brass} strokeWidth="3" strokeLinecap="round" />
        <path
          d="M 290.1 55.8 A 24 24 0 1 1 303.2 40.2"
          fill="none"
          stroke={c.brass}
          strokeWidth="6"
          strokeLinecap="round"
        />
        <text
          x="280"
          y="98"
          textAnchor="middle"
          fontFamily="Merriweather, Georgia, serif"
          fontWeight="900"
          fontSize="46"
          letterSpacing="2.5"
          fill={c.wordmark}
        >
          ONE MORE SHIFT
        </text>
      </svg>
      <span
        className={`max-sm:hidden mt-1 text-center text-[13px] font-semibold tracking-[0.22em] ${
          variant === "reversed" ? "text-[#E9E6DF]" : "text-foreground"
        }`}
      >
        EXPERIENCE DOESN'T RETIRE.
      </span>
    </span>
  );
};

export default BrandLogo;
